import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {QueryApiService} from '@core/services/query-api.service';
import {GraphqlUtility} from '@shared/utility/graphql-utility';
import {InboxQueries} from '../queries/inbox-queries';
import {InboxModel, ReplyMessageModel} from '../models/inbox.model';
import {Observable} from 'rxjs';
import {InboxConfig} from '../inbox-config';

@Injectable()
export class InboxApiService {
  constructor(private httpClient: HttpClient) {
  }

  getMailLabels(): Observable<InboxModel> {
    const graphQlApiUrl = GraphqlUtility.getGraphQLUrlFromApiKey('AlertApi');
    const query = InboxQueries.getAllInboxLabels();
    return this.httpClient.post<InboxModel>(graphQlApiUrl, query);
  }

  getMailById(id: string): Observable<any> {
    return this.httpClient.get<any>(InboxConfig.getMailByIdApi(id));
  }

  getAllRecepients(): Observable<any> {
    return this.httpClient.get<any>(InboxConfig.getAllRecepientsApi());
  }

  getAllMailsByLabel(label: string): Observable<any> {
    const body = {
      startIndex: 0,
      endIndex: 30,
      fieldSectionId: 'platformmail',
      sortField: 'LastModifiedDate',
      isAssending: false,
      parameters: {'FIELD_SECTION_ID': 'platformmail'},
      filters: []
    };
    return this.httpClient.post<any>(InboxConfig.getAllMailsByLabel(label), body);
  }
}
